module.exports = __webpack_public_path__ + "static/image/font/baeminGeullim.ver2_0_2.png?4ad577eb";